import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SiteLayout from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import ActivitiesPage from "@/pages/ActivitiesPage";
import GalleryPage from "@/pages/GalleryPage";
import PartnersPage from "@/pages/PartnersPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AuthProvider } from "@/lib/auth";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          {/* Public site */}
          <Route path="/" element={<SiteLayout><HomePage /></SiteLayout>} />
          <Route path="/about" element={<SiteLayout><AboutPage /></SiteLayout>} />
          <Route path="/products" element={<SiteLayout><ProductsPage /></SiteLayout>} />
          <Route path="/activities" element={<SiteLayout><ActivitiesPage /></SiteLayout>} />
          <Route path="/gallery" element={<SiteLayout><GalleryPage /></SiteLayout>} />
          <Route path="/partners" element={<SiteLayout><PartnersPage /></SiteLayout>} />
          <Route path="/contact" element={<SiteLayout><ContactPage /></SiteLayout>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
